import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { environment } from "@edp-environments/environment";
import { AddUploadedFile, UploadCustomerSupportFile } from "@edp-store/actions/file-upload.actions";
import { IAppState } from "@edp-store/state/app.state";
import { getMimeType } from "@edp-utils/get-mimetype.utils";
import { Store } from "@ngrx/store";
import moment from "moment";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

const argsContentRep = {
    prod: "CP",
    dev: "CQ",
};

@Component({
    selector: "energetic-certification",
    templateUrl: "./energetic-certification.component.html",
    styleUrls: ["./energetic-certification.component.scss"],
})
export class EnergeticCertificationComponent implements OnInit {
    @Input() request: any;
    @Input() argsFileCertification: { fileCPU: string; fileCRP: string; fileTRTO: string; filePCT: string; fileOther: string };
    @Output() submitData = new EventEmitter();
    public form: FormGroup;
    private isProduction = false;
    public fieldFileToToSet = "ArchObj";
    public valuesFileToSet = [];

    constructor(private fb: FormBuilder, private store: Store<IAppState>) {
        this.form = this.fb.group({
            energeticCertification: new FormGroup({
                response: new FormControl(null, Validators.required),
            }),
        });

        this.form.valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(() => {
            if (!!this.form.valid) {
                this.submitData.emit(this.response);
            }
        });
    }

    public ngOnInit(): void {
        this.isProduction = !!environment.production;
        this.valuesFileToSet = [
            { toSet: this.argsFileCertification.fileCPU, label: "pt.edp.edponline.request.operations.energetic.certification.doc1" },
            { toSet: this.argsFileCertification.fileCRP, label: "pt.edp.edponline.request.operations.energetic.certification.doc2" },
            {
                toSet: this.argsFileCertification.fileTRTO,
                label: "pt.edp.edponline.request.operations.energetic.certification.doc3",
                conditionResponse: "N",
            },
            {
                toSet: this.argsFileCertification.filePCT,
                label: "pt.edp.edponline.request.operations.energetic.certification.doc4",
                conditionResponse: "N",
            },
            {
                toSet: this.argsFileCertification.fileOther,
                label: "pt.edp.edponline.request.operations.energetic.certification.doc.other",
            },
        ];
    }

    public onUploadFile(event) {
        const id = Date.now();
        const mimeType = getMimeType(event.name);

        const argsDefaultGas = {
            mimeType,
            id,
            ContentRep: this.isProduction ? argsContentRep.prod : argsContentRep.dev,
            AdditionalObjects: [{ name: "RECEPTDATE", value: moment().format("YYYYMMDD") }],
        };

        this.store.dispatch(new AddUploadedFile({ ...event, ...argsDefaultGas }));

        this.store.dispatch(
            new UploadCustomerSupportFile({
                name: event.name,
                size: event.size,
                base64: event.file,
                modified: null,
                error: null,
                ...argsDefaultGas,
            })
        );
    }

    get response() {
        return this.form.get("energeticCertification").value.response;
    }
}
